import type { MouseEventHandler } from 'react';

import { useTranslation } from 'react-i18next';
import {
  ChevronUp as ChevronUpIcon,
  ChevronDown as ChevronDownIcon,
} from '@vgno/icons';

import { Button } from '../Button/Button';

type Props = {
  isExpanded?: boolean;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

function ExpandButton(props: Props) {
  const { isExpanded, className, onClick } = props;
  const { t } = useTranslation();

  const buttonLabel = t(isExpanded ? 'See less' : 'See more');

  return (
    <Button size="small" variant="text" className={className} onClick={onClick}>
      {buttonLabel}
      {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Button>
  );
}

export { ExpandButton };
